module.exports = __webpack_public_path__ + "static/media/SM-ST-5.5d0333b1.mp3";